import React from 'react';

import { ExecutionStatus } from '@qality/common-model';
import { CssUtils, StringUtils } from '@qality/common-utils';

import {
  CellWrapperStyled,
  ColorSquareStyled,
  ColorTextStyled,
} from './Color.styled';

type Props = {
  status: ExecutionStatus;
};

export default function Color({ status }: Props): JSX.Element {
  return (
    <CellWrapperStyled>
      <ColorSquareStyled
        color={CssUtils.cssDsTokenVar(status.color.backgroundToken)}
      />
      <ColorTextStyled>
        {StringUtils.capitalize(status.color.name)}
      </ColorTextStyled>
    </CellWrapperStyled>
  );
}
